import styled from 'styled-components';

const Ul = styled.ul`
  word-break: normal;
  margin: 24px 0 0;
  padding: 16px 20px;
  background: var(--medium-lightBlue);
  font-size: 13px;
  border-radius: 4px;
  li {
    display: flex;
    position: left;
    margin: 0;
    padding: 6px 0;
    list-style: none;
    line-height: 18px;
    &::before {
      content: '•';
      margin-right: 12px;
      color: var(--medium-blue);
      font-weight: 600;
      font-size: 11px;
    }
  }
`;

export { Ul };
